import React from 'react';
import { ColumnsType } from 'antd/lib/table';
import { getI18n } from 'react-i18next';
import TableHeader from '~/pages/agent/components/agent/tableElements/TableHeader';
import { AgentLead } from '~/types/AgentLead';
import { AgentApplication } from '~/types/AgentApplication';
import { queryClient } from '~/index';
import { RiskLevel } from '~/types/RiskLevel';
import RiskLevelSelect from '~/components/inputs/RiskLevelSelect';
import { getDecodedJwt } from '~/utils/getDecodedJwt';

function riskLevelCell(type: 'LEAD' | 'APPLICATION'): ColumnsType<any>[0] {
  const currUserEmail = getDecodedJwt()?.email;
  return {
    title: () => (
      <TableHeader title={getI18n().t('Risk level', { ns: 'agent' })} sortingDataKey="riskLevel" />
    ),
    key: 'riskLevel',
    dataIndex: 'riskLevel',
    render: (tag: RiskLevel, record: AgentLead | AgentApplication) => {
      const disabled =
        type === 'LEAD' ||
        record?.statusKey !== 'onReview' ||
        record.assignee?.email !== currUserEmail;
      return (
        <RiskLevelSelect
          type={type}
          currentValue={tag}
          recordId={'leadId' in record && type === 'LEAD' ? record?.leadId : record?.applicationId}
          disabled={disabled}
          onAfterChange={() => {
            void queryClient.refetchQueries('applications');
          }}
        />
      );
    },
    width: 120,
  };
}

export default riskLevelCell;
